module.exports = __webpack_public_path__ + "static/media/08_aermel.66d70f80.jpg";